import { ABOUT } from "@/data/content";
import SectionHeader from "@/components/common/SectionHeader";

export default function Philosophy() {
  return (
    <section className="section-y bg-[#0B1A3D] text-white relative overflow-hidden" data-testid="home-philosophy">
      <div className="grain-overlay" />
      <div className="absolute -top-32 right-0 h-96 w-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(242,140,31,.2) 0%, transparent 70%)" }} />
      <div className="absolute -bottom-32 left-0 h-96 w-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(27,58,142,.4) 0%, transparent 70%)" }} />

      <div className="container-sf relative">
        <div className="max-w-3xl mb-14">
          <div className="eyebrow text-[var(--brand-orange)] mb-4">Filosofi Organisasi</div>
          <h2 className="text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.05] tracking-tight text-white">
            Bersandar pada empat pilar{" "}
            <span className="font-serif-display italic font-normal text-[var(--brand-orange)]">Sunda</span> yang luhur.
          </h2>
          <p className="mt-5 text-lg text-slate-300 leading-relaxed">
            Setiap tindakan kami berakar pada kearifan lokal Sunda — kebersamaan, kasih sayang, pengembangan, dan perlindungan lintas generasi.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {ABOUT.philosophy.map((p, i) => (
            <div
              key={p.key}
              className="group relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur p-7 hover:border-[var(--brand-orange)]/50 transition-all hover:-translate-y-1"
              data-testid={`philosophy-${p.title.toLowerCase().replace(' ','-')}`}
            >
              <div className="text-6xl font-serif-display italic text-[var(--brand-orange)]/40 leading-none mb-3">0{i + 1}</div>
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--brand-orange)] mb-2">
                {p.subtitle}
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{p.title}</h3>
              <p className="text-sm text-slate-300 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
